import mixpanel from "./mixpanel.config";
import type { ITrackChatbotPanelOpenedParams } from "./track-chatbot-panel-opened.interface";

export const CHATBOT_PANEL_OPENED_EVENT_NAME = "chatbot-panel-opened";

export function trackChatbotPanelOpened(params: ITrackChatbotPanelOpenedParams): void {
  const { accountId, userTierAtEvent, entryPoint } = params;

  mixpanel.track(CHATBOT_PANEL_OPENED_EVENT_NAME, {
    distinct_id: accountId,
    userTierAtEvent,
    entryPoint,
  });
}
